import React, { useState } from 'react';
import { Modal, Switch, Typography, Space, Button, Divider } from 'antd';
import { useCookieConsent } from '../../hooks/useCookieConsent';

const { Text, Title } = Typography;

interface CookieSettingsModalProps {
  open: boolean;
  onClose: () => void;
}

export const CookieSettingsModal: React.FC<CookieSettingsModalProps> = ({ open, onClose }) => {
  const { preference, activePolicyVersion, updatePreference } = useCookieConsent();
  const [marketingEnabled, setMarketingEnabled] = useState(preference?.marketing ?? false);

  const handleSave = () => {
    if (!activePolicyVersion) return;
    updatePreference(marketingEnabled, activePolicyVersion);
    onClose();
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title="Configurações de cookies"
      footer={[
        <Button key="cancel" onClick={onClose}>
          Cancelar
        </Button>,
        <Button key="save" type="primary" onClick={handleSave}>
          Salvar preferências
        </Button>,
      ]}
      width={480}
    >
      <Space direction="vertical" style={{ width: '100%' }} size={16}>
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Title level={5} style={{ margin: 0 }}>Cookies essenciais</Title>
            <Switch checked disabled />
          </div>
          <Text type="secondary" style={{ fontSize: 13 }}>
            Necessários para autenticação, segurança e funcionamento básico da plataforma.
            Não podem ser desativados.
          </Text>
        </div>

        <Divider style={{ margin: '4px 0' }} />

        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Title level={5} style={{ margin: 0 }}>Cookies de marketing</Title>
            <Switch
              checked={marketingEnabled}
              onChange={setMarketingEnabled}
            />
          </div>
          <Text type="secondary" style={{ fontSize: 13 }}>
            Google Tag Manager e Meta Pixel — usados para medir o alcance de nossas campanhas.
            Você pode desativar a qualquer momento. Não afeta o recebimento de emails de
            comunicação da PePoll — isso é controlado separadamente, ao lado.
          </Text>
        </div>
      </Space>
    </Modal>
  );
};
